module.exports = __webpack_public_path__ + "img/noFace.4a4a1367.png";